import { createSlice } from '@reduxjs/toolkit';

export const servicesIaCustomerSuscriptionsSlice = createSlice({
  name: 'servicesIaSuscriptions',
  initialState: {
    suscriptions_for_select: [],
    customer_for_select: [],
    suscription: {},
    suscriptions_list: [],
  },
  reducers: {
    setPlansFormOptionsRedux: (state, { payload }) => {
      state.suscriptions_for_select = payload;
    },
    setCustomerFormOptionsRedux: (state, { payload }) => {
      state.customer_for_select = payload;
    },
    setSuscriptionRedux: (state, { payload }) => {
      state.suscription = payload;
    },
    setSuscriptionsForSelectRedux: (state, { payload }) => {
      state.suscriptions_list = payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setSuscriptionsForSelectRedux,
  setCustomerFormOptionsRedux,
  setSuscriptionRedux,
  setPlansFormOptionsRedux,
} = servicesIaCustomerSuscriptionsSlice.actions;
